import { setSessionStart } from '../userStatus/session';

const onMessageSend = () => {
    setSessionStart();
};

export { onMessageSend };
